/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import MLTextField from '../../../MLTextField/MLTextField';
import MLButton from '../../../MLButton';

import s from './LinkAccount.module.css';

const LinkAccount = ({
  email,
  password,
  errorMessage,
  userIsStudent,
  userIsInstructor,
  createAccountLink,
  forgotPasswordLink,
  handleEmailChange,
  handlePasswordChange,
  handleLinkReef,
}) => {
  return (
    <div
      className={`${s.reefBody} ${userIsStudent ? s.student : ''}`}
      data-test-id="reef-link-account"
    >
      {userIsInstructor && (
        <div className={s.loginText} data-test-id="reef-login-text">
          Sign in using your existing iClicker Cloud account.
        </div>
      )}
      <form className={s.inputWrapper}>
        {userIsInstructor && <span className={s.label}>Email</span>}
        <MLTextField
          autoFocus
          testId="reef_modal_email_input"
          containerClassName={`${s.inputContainer} ${
            errorMessage ? s.inputError : ''
          }`}
          className={s.input}
          placeholder="Email"
          type="email"
          value={email}
          onChange={handleEmailChange}
          hasError={!isEmpty(errorMessage)}
        />
        {userIsInstructor && <span className={s.label}>Password</span>}
        <MLTextField
          autoFocus
          testId="reef_modal_password_input"
          containerClassName={`${s.inputContainer} ${
            errorMessage ? s.inputError : ''
          }`}
          className={s.input}
          placeholder="Password"
          type="password"
          value={password}
          onChange={handlePasswordChange}
          hasError={!isEmpty(errorMessage)}
        />
        <a
          className={s.forgotPassword}
          href={forgotPasswordLink}
          target="_blank"
          rel="noopener noreferrer"
          data-test-id="reef-forgot-password-link"
        >
          Forgot Password?
        </a>
        <div className={s.buttonContainer}>
          <MLButton
            className={s.signInBtn}
            btnType="primary"
            testId="reef_modal_sign_in"
            disabled={!!(!(email || password) || errorMessage)}
            onClick={handleLinkReef}
          >
            Sign In
          </MLButton>
        </div>
        <div className={s.createAccountContainer}>
          Don't have an account?
          <a
            className={s.signUpLink}
            href={createAccountLink}
            target="_blank"
            rel="noopener noreferrer"
            data-test-id="reef-sign-up-link"
          >
            Sign up!
          </a>
        </div>
      </form>
      {errorMessage && (
        <div className={s.errorMessageContainer} data-test-id="reef-error-text">
          <span className={s.errorMessageText}>{errorMessage}</span>
        </div>
      )}
    </div>
  );
};

LinkAccount.propTypes = {
  email: PropTypes.string,
  password: PropTypes.string,
  errorMessage: PropTypes.string,
  userIsStudent: PropTypes.bool,
  userIsInstructor: PropTypes.bool,
  createAccountLink: PropTypes.string,
  forgotPasswordLink: PropTypes.string,
  handleEmailChange: PropTypes.func,
  handlePasswordChange: PropTypes.func,
  handleLinkReef: PropTypes.func,
};

export default LinkAccount;
